export default "__VITE_ASSET__7cbb61f3__"